import React from "react";
import PropTypes from "prop-types";
import { Grid, Box } from "adry-commons-ui";

function PlayerGrid({ size, children }) {
  if (!["xlarge", "large", "medium"].includes(size)) {
    return <Box>{children}</Box>;
  }

  return (
    <Grid
      columns={["1fr", "1fr"]}
      rows={["flex"]}
      areas={[
        {
          name: "left",
          start: [0, 0],
          end: [1, 0]
        },
        {
          name: "right",
          start: [1, 0],
          end: [1, 0]
        }
      ]}
      fill
    >
      {children}
    </Grid>
  );
}

PlayerGrid.propTypes = {
  size: PropTypes.string,
  children: PropTypes.node
};

export default PlayerGrid;
